// import { Header } from '../../Components/index'
import { MdEmail } from "react-icons/md";
import { BsMessenger } from "react-icons/bs";
import { IoLogoWhatsapp } from "react-icons/io";
import { Fragment } from "react";
import Map from "../../Components/Map/Map";

import "./contact.css";
const Contact = () => {
  return (
    <Fragment>
      <div className="map">
        <Map />
      </div>
      <section className="contact">
        <div className="container contact__container">
          <div className="contact__wrapper">
            <a
              href="mailto:info@biladygroup.com"
              target="_blank"
              rel="noreferrer"
            >
              <MdEmail />
            </a>
            <a
              href="https://business.facebook.com/latest/inbox/messenger?asset_id=105649165067803&bpn_id=477382073338738&nav_ref=diode_page_inbox_comet_profile_plus_ap_page_inbox_message_button&selected_item_id=100042783662899&mailbox_id=105649165067803"
              target="_blank"
              rel="noreferrer"
            >
              <BsMessenger />
            </a>
            <a
              href="https://wa.me/+964750963000"
              target="_blank"
              rel="noreferrer"
            >
              <IoLogoWhatsapp />
            </a>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Contact;
